// @ts-nocheck
import {
  FETCH_CUSTOMER_FULFILLED,
  FETCH_CUSTOMER_REJECTED,
  FETCH_REGIONS_FULFILLED,
  FETCH_REGIONS_REJECTED,
  FETCH_PARTNERS_FULFILLED,
  FETCH_PARTNERS_REJECTED,
  SEARCH_CUSTOMERS_FULFILLED,
  SEARCH_CUSTOMERS_REJECTED,
} from './customerActionTypes';

const initialState = {
  customers: null,
  customerDetails: null,
  regions: null,
  partners: null,
};

export default function customerReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_CUSTOMERS_FULFILLED:
      return {
        ...state,
        customers: action.payload,
      };
    case SEARCH_CUSTOMERS_REJECTED:
      return {
        ...state,
        customers: null,
      };
    case FETCH_CUSTOMER_FULFILLED:
      return {
        ...state,
        customerDetails: action.payload,
      };
    case FETCH_CUSTOMER_REJECTED:
      return {
        ...state,
        customerDetails: null,
      };
    case FETCH_REGIONS_FULFILLED:
      return {
        ...state,
        regions: action.payload,
      };
    case FETCH_REGIONS_REJECTED:
      return {
        ...state,
        regions: null,
      };
    case FETCH_PARTNERS_FULFILLED:
      return {
        ...state,
        partners: action.payload,
      };
    case FETCH_PARTNERS_REJECTED:
      return {
        ...state,
        partners: null,
      };
    default:
      return state;
  }
}
